var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',[_vm._v(_vm._s(_vm.value.name))]),_c('b-badge',{staticClass:"pt-1",class:`document-status-button color-${_vm.value.status.id}`,attrs:{"variant":"info"}},[_vm._v(_vm._s(_vm.value.status.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }